const Footer = () => {
    return (
        <footer style={{ textAlign: 'center', padding: '20px' }}>
            <p>&copy; 2026 E2 Synergy Ltd. All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;